import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHead = ({ 
  title = "Smarte Buchhaltung Online - Digitalisierung mit Lexware Office",
  description = "Digitalisieren Sie Ihre Buchhaltung mit Lexware Office. Professionelle Beratung für Solo-Selbstständige & kleine Unternehmen. Kostenloses Erstgespräch.",
  keywords = "buchhaltung digitalisieren, lexware office einrichtung, digitale buchhaltung für selbstständige, ust-voranmeldung online, datev export, belege automatisch verbuchen, lexware office coach",
  canonical = "https://smarte-buchhaltung.online/",
  ogImage = "https://smarte-buchhaltung.online/og-image.jpg"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHead;